<input type="text"
       class="form-control box-shadow mask mat-mdc-card search-input"
       placeholder="Search Cameras"
       autocomplete="off"
       [(ngModel)]="searchText"
       (keyup)="searchChanged($event)"
       (keydown.enter)="$event.preventDefault()"
        />

<mat-card class="search-result-card">
  <mat-selection-list [multiple]="false">
    <mat-list-option [appScrollIntoView]="device.uiState.selected"
                     *ngFor="let device of devices"
                     (mouseenter)="highlightDevice(device)"
                     (mouseleave)="unHighlightDevice(device)"
                     (click)="selectDevice(device)"
                     [class.selected]="device.uiState.selected">

      <div matListItemTitle class="device-title">
        <svg class="device-icon" xmlns="http://www.w3.org/2000/svg" [attr.viewBox]="device.sourceType === 0 ? '2 0 50 50' : '-20 0 145 145'">
          <path [attr.d]="device.iconPath" />
        </svg>
        <div class="device-option" [attr.title]="device.name">{{device.name}}</div>
        <div class="state-icons">
          <div *ngIf="device.gpsState != 1" class="recording-icon">
            <svg>
              <use fill="red" href="/angular/webforms/assets/img/camera-realtime-map/gps-lost.svg#icon"></use>
            </svg>
          </div>
          <div *ngIf="device.isRecording" class="recording-icon">
            <svg>
              <use fill="red" href="/angular/webforms/assets/img/camera-realtime-map/recording.svg#icon"></use>
            </svg>
          </div>
          <div *ngIf="device.isStreaming" class="recording-icon">
            <svg>
              <use fill="red" href="/angular/webforms/assets/img/camera-realtime-map/streaming.svg#icon"></use>
            </svg>
          </div>
        </div>
      </div>
      <div class="meta-data" *ngIf="(device.isStreaming || device.isRecording) && device.triggerSource !== null && device.triggerTime !== null">
        <div matListItemLine *ngIf="device.triggerSource" [attr.title]="device.triggerSource"><span class="meta-title">Triggered by </span> <b>{{ device.triggerSource }}</b></div>
        <div matListItemLine><span class="meta-title">Event time </span> <b>{{ device.triggerTime | date : 'short' }}</b></div>
      </div>
      <div>
        <button mat-raised-button [class.streaming]="selectedDevice != null && selectedDevice.id == device.id" *ngIf="streamEnabled && device.isStreaming" (click)="loadStream($event, device)">View Stream</button>
      </div>
    </mat-list-option>
  </mat-selection-list>
</mat-card>

